var voted_users_default = {
  "container": "jEYbJ",
  "webview": "JyAuE",
  "avatar_list": "x6Jfp",
  "avatar": "ysCX9",
  "user_avatar": "_0dgBv",
  "modal": "JjhiN",
  "voted_users_modal": "YXX2-",
  "overlay": "_23CKT",
  "user_card": "xO4Y0",
  "user_name": "LWd3f",
  "voted_users_modal_header": "NUAs9",
  "cta": "ejprl",
  "close_icon": "E4wjz",
  "title": "mA2mS",
  "member_list_container": "cbGEu",
  "member_list": "aLLMr",
  "loader": "wfSKA",
  "anonymous_counter": "_3rktx",
  "spinner": "CZNYM",
  "spin": "v9tFU"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
